/* tslint:disable */
/* eslint-disable */
/**
 * EH Commissioning WebAPI 1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import { ErrorResponse, ErrorResponseFromJSON, ErrorResponseFromJSONTyped, ErrorResponseToJSON } from "./ErrorResponse";
import { TagIssue, TagIssueFromJSON, TagIssueFromJSONTyped, TagIssueToJSON } from "./TagIssue";

/**
 *
 * @export
 * @interface TagIssueListControllerResponse
 */
export interface TagIssueListControllerResponse {
  /**
   *
   * @type {Array<TagIssue>}
   * @memberof TagIssueListControllerResponse
   */
  data?: Array<TagIssue> | null;
  /**
   *
   * @type {ErrorResponse}
   * @memberof TagIssueListControllerResponse
   */
  error?: ErrorResponse;
}

export function TagIssueListControllerResponseFromJSON(json: any): TagIssueListControllerResponse {
  return TagIssueListControllerResponseFromJSONTyped(json, false);
}

export function TagIssueListControllerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TagIssueListControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data")
      ? undefined
      : json["data"] === null
      ? null
      : (json["data"] as Array<any>).map(TagIssueFromJSON),
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function TagIssueListControllerResponseToJSON(value?: TagIssueListControllerResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data:
      value.data === undefined
        ? undefined
        : value.data === null
        ? null
        : (value.data as Array<any>).map(TagIssueToJSON),
    error: ErrorResponseToJSON(value.error),
  };
}
